import { AxiosResponse } from 'axios'
import { privateApi } from 'api'
import {
  IAdminSellerNotice,
  ISaveSellerNotice,
  ISellerNotice
} from 'models/sellerNotices'

export const sellerNoticesApi = {
  getForSeller(): Promise<AxiosResponse<ISellerNotice[]>> {
    return privateApi.get('seller-notices')
  },
  hide(id: string): Promise<AxiosResponse> {
    return privateApi.patch(`seller-notices/${id}/hide`)
  },
  getAll(): Promise<AxiosResponse<IAdminSellerNotice[]>> {
    return privateApi.get('admin/seller-notices')
  },
  create(data: ISaveSellerNotice): Promise<AxiosResponse> {
    return privateApi.post('admin/seller-notices', data)
  },
  update(id: string, data: ISaveSellerNotice): Promise<AxiosResponse> {
    return privateApi.patch(`admin/seller-notices/${id}`, data)
  },
  remove(id: string): Promise<AxiosResponse> {
    return privateApi.delete(`admin/seller-notices/${id}`)
  }
}
